<template>
  <TemplatesContentfulMedia />
</template>

<script setup>
defineOptions({
  name: 'MediaPostPage'
})
</script>
